import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions';
import { UserListItem, UserStatus } from '@rootCommon/types/user';
import {
  ListResultState, SortingBy, OrderBy, IdType,
} from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
type OwnState = { groupId?: IdType | null };
export type UsersState = ListResultState<UserListItem> & OwnState;

const initState: UsersState = {
  data: null,
  loading: false,
  error: null,
  filter: { search: '', orderBy: OrderBy.REGISTRATION_DATE, sorting: SortingBy.ASC },
  groupId: null,
};

export const usersListReducer = (state = initState, action: Action): UsersState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchUsers.request):
      return { ...state, loading: true };
    case getType(actions.fetchUsers.success):
      return {
        ...state,
        loading: false,
        data: { items: action.payload.items, total: action.payload.total },
        groupId: null,
      };
    case getType(actions.fetchUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // delete ids
    case getType(actions.deleteUsers.request):
      return { ...state, loading: true };
    case getType(actions.deleteUsers.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const newItems = items.filter((item) => !action.payload.includes(item.id));

      return { ...state, data: { items: newItems, total: items.length }, loading: false };
    }
    case getType(actions.deleteUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // enable ids
    case getType(actions.enableUsers.request):
      return { ...state, loading: true };
    case getType(actions.enableUsers.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const updItems = items.map((item) => (action.payload.includes(item.id)
        ? { ...item, status: UserStatus.ENABLED } : item));

      return { ...state, data: { items: updItems, total: state.data?.total || 0 }, loading: false };
    }
    case getType(actions.enableUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // lock ids
    case getType(actions.lockUsers.request):
      return { ...state, loading: true };
    case getType(actions.lockUsers.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const updItems = items.map((item) => (action.payload.includes(item.id)
        ? { ...item, status: UserStatus.LOCKED } : item));

      return { ...state, data: { items: updItems, total: state.data?.total || 0 }, loading: false };
    }
    case getType(actions.lockUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // filter
    case getType(actions.setUsersFilter):
      return { ...state, filter: action.payload };

      // fetch by user group id
    case getType(actions.fetchUsersByGroupId.request):
      return { ...state, loading: true };
    case getType(actions.fetchUsersByGroupId.success):
      return {
        ...state,
        loading: false,
        data: { items: action.payload.data.items, total: action.payload.data.total },
        groupId: action.payload.groupId,
      };
    case getType(actions.fetchUsersByGroupId.failure):
      return { ...state, loading: false, error: action.payload };

      // filter users by group
    case getType(actions.setUsersByGroupIdFilter):
      return { ...state, filter: action.payload.filters };

      // ungroup ids
    case getType(actions.ungroupUsers.request):
      return { ...state, loading: true };
    case getType(actions.ungroupUsers.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const newItems = items.filter((item) => !action.payload.includes(item.id));

      return { ...state, data: { items: newItems, total: items.length }, loading: false };
    }
    case getType(actions.ungroupUsers.failure):
      return { ...state, loading: false, error: action.payload };

      // default
    default:
      return state;
  }
};

export default usersListReducer;
